import React, { FC } from 'react';
import Helmet from 'react-helmet';

type Props = {
  url: string;
};

export const HeadGoogleMarkup: FC<Props> = ({ url }) => (
  <Helmet>
    {url === '/' && (
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'http://schema.org',
          '@type': 'WebSite',
          name: 'Doctrine',
          alternateName: 'Doctrine.fr',
          url: 'https://www.doctrine.fr',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://www.doctrine.fr/search?q={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
        })}
      </script>
    )}

    <script type="application/ld+json">
      {JSON.stringify({
        '@context': 'http://schema.org',
        '@type': 'Organization',
        url: 'https://www.doctrine.fr',
        logo: 'https://www.doctrine.fr/img/logo/logos_doctrine/logo_navbar.png',
        sameAs: [
          'https://www.linkedin.com/company/doctrine',
          'https://www.twitter.com/doctrine',
          'https://www.facebook.com/doctrineFR/',
          'https://www.youtube.com/c/DoctrineFr',
          'https://www.angel.co/doctrine-',
          'https://www.crunchbase.com/organization/doctrine',
        ],
        contactPoint: [
          {
            '@type': 'ContactPoint',
            telephone: '+33 1 84 80 33 48',
            contactType: 'sales',
            contactOption: 'TollFree',
            areaServed: ['FR', 'BE'],
            availableLanguage: ['French', 'English'],
          },
        ],
      })}
    </script>
  </Helmet>
);
